import {Component, Inject, OnInit} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {HelperService} from "../../../services/helpers/helper.service";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';
import {NgIf, NgSwitch, NgSwitchCase} from '@angular/common';

@Component({
    selector: 'app-how-to-post-data',
    templateUrl: './how-to-post-data.component.html',
    styleUrls: ['./how-to-post-data.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent, NgSwitch, NgSwitchCase, NgIf]
})
export class HowToPostDataComponent implements OnInit {
  url: string
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      endpoint: string,
      bearer?: string
      section: string
    },
    public dialogRef: MatDialogRef<HowToPostDataComponent>,
    public helperSvc: HelperService
  ) { }

  ngOnInit(): void {
    this.url = environment.core + 'v2/' + this.data.endpoint
  }

}
